import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { jwtDecode } from 'jwt-decode';

// Role-based redirect:
// - Workers go to /worker (their dashboard)
// - Managers/Admins go to /map/planner (server-rendered map planner)
const RootRedirect = () => {
  const { user, effectiveRole } = useAuth();

  useEffect(() => {
    let target = '/map/planner';
    // effectiveRole respects view mode — a manager in field view stays in the app
    if ((effectiveRole || user?.role) === 'worker') {
      target = '/worker';
    }
    // Full navigation — /map/planner is a server-rendered page outside React
    window.location.replace(target);
  }, [user]);

  return null;
};

export default RootRedirect;
